import { registerFeatureTranslations } from '@/core/i18n';
import type { TranslationSchema } from '@/core/types/translation.types';
import en from './en.json';
import es from './es.json';

export function registerClientContactsTranslations() {
  registerFeatureTranslations<TranslationSchema>('clientContacts', { es, en });
}

export const clientContactsLocales = { en, es };

export type ClientContactsLocales = typeof clientContactsLocales;
